module.exports = __webpack_public_path__ + "static/img/shezhi_xiaoxi.402c5bd9.png";